import React from 'react';
import { Schedule } from '../models/Schedule.tsx';

export type ScheduleDateSection = {
  dateKey: string;
  games: Schedule[];
};

export type ScheduleLeagueSection = {
  leagueKey: string;
  dates: ScheduleDateSection[];
};

export function buildLeagueSections(games: Schedule[]): ScheduleLeagueSection[] {
  const leagues: ScheduleLeagueSection[] = [];

  for (const game of games) {
    const leagueKey = game.leagueKey;
    const dateKey = new Date(game.start_date).toDateString();

    let league = leagues.find(item => item.leagueKey === leagueKey);
    if (!league) {
      league = { leagueKey, dates: [] };
      leagues.push(league);
    }

    let dateSection = league.dates.find(item => item.dateKey === dateKey);
    if (!dateSection) {
      dateSection = { dateKey, games: [] };
      league.dates.push(dateSection);
    }

    dateSection.games.push(game);
  }

  return leagues;
}

export function formatScheduleDate(startDate: string): string {
  return new Date(startDate).toLocaleDateString('en-US', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  }).toUpperCase();
}

export function ScheduleDateHeader({ startDate }: { startDate: string }) {
  return (
    <div className="schedule-date-header">
      <div className="header-table">
        <div className="container-date team-name-container">
          <span className="group ps-1">{formatScheduleDate(startDate)}</span>
          <span className="group"></span>
        </div>
        <div className="spread-container center-items">
          <span className="group"></span>
        </div>
        <div className="moneyline-container center-items d-none d-lg-block">
          <span className="group"></span>
        </div>
        <div className="total-container center-items">
          <span className="group"></span>
        </div>
        <div className="over-under-container center-items d-none d-lg-block">
          <span className="group"></span>
        </div>
      </div>
    </div>
  );
}
